import type { ReactNode } from 'react';
import type { ColumnDef } from '@tanstack/react-table';
import type { PcmpRequestedItem } from '../../types/pcmpRequested.types';
import { getPcmpQueueColumns } from '../PcmpQueue/pcmpQueueColumns';
import {
  pcmpPaymentSourceColumn,
  pcmpRequestSummaryColumns,
} from '../PcmpRequests/PcmpRequestColumns';

const divisionColumn: ColumnDef<PcmpRequestedItem> = {
  id: 'division',
  header: 'Division',
  cell: ({ row }) => (
    <div className="flex flex-col">
      <span className="whitespace-nowrap">{row.original.division ?? 'Not Mapped'}</span>
      {row.original.region ? (
        <span className="text-xs whitespace-nowrap text-muted-foreground">
          {row.original.region}
        </span>
      ) : null}
    </div>
  ),
};

interface PcmpRequestedColumnOptions {
  leading?: ColumnDef<PcmpRequestedItem>[] | undefined;
  renderActions: (item: PcmpRequestedItem) => ReactNode;
}

/** The Requested Proposals columns: the queue's, the division and the request itself. */
export function getPcmpRequestedColumns({
  leading,
  renderActions,
}: PcmpRequestedColumnOptions): ColumnDef<PcmpRequestedItem>[] {
  return getPcmpQueueColumns<PcmpRequestedItem>({
    leading,
    afterAmounts: [pcmpPaymentSourceColumn(), divisionColumn],
    afterLanes: pcmpRequestSummaryColumns<PcmpRequestedItem>(),
    renderActions,
  });
}
